import EditIcon from "@mui/icons-material/Edit";
import { Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTable from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import { getDiagnosticTemplates } from "../../../redux/reducers/clinicSlice";
import { deleteTreatmentPlanById } from "../../../redux/reducers/planSlice";
import { AppColors } from "../../../util/AppColors";
import { eyeBtn } from "../../../util/CommonIconStyle";
import DiagnosticTemplateCreate from "./DiagnosticTemplateCreate";

const tableHeader = ["templateName", "createdBy", "lastUpdated", "extraStatus"];

const DiagnosticTemplate = () => {
  const dispatch = useDispatch();
  const [createVsble, setCreateVsble] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [delModVsble, setDelModVsble] = useState(false);
  const [selectedTemp, setSelectedTemp] = useState(null);
  const { diagnosticTemplates } = useSelector((state) => state?.clinic);

  useEffect(() => {
    dispatch(getDiagnosticTemplates());
  }, []);

  const handleDelete = (det) => {
    setSelectedTemp(det);
    setDelModVsble(true);
  };

  const handleEdit = (det) => {
    setSelectedTemp(det);
    setCreateVsble(true);
  };

  const handleCloseDel = () => {
    setSelectedTemp(null);
    setDelModVsble(false);
  };

  const handleConfirmDel = () => {
    dispatch(deleteTreatmentPlanById(selectedTemp?.templateId)).then((res) => {
      if (res?.payload) {
        dispatch(getDiagnosticTemplates());
        handleCloseDel();
      }
    });
  };

  const getTableList = () => {
    return diagnosticTemplates?.map((pln) => ({
      templateName: pln?.templateName,
      createdBy: pln?.clinicId,
      lastUpdated: moment(new Date(pln?.createdDate)).format("DD MMM YYYY"),
      extraStatus: (
        <div className="flex-row">
          {/* <div className="cursor" onClick={() => handleDelete(pln)}>
            <div className="flex-center">
              <DeleteOutlineIcon sx={delBtn} />
            </div>
            <Typography className="red3 fs8 txt-semi-bold text-align-center">
              Delete
            </Typography>
          </div> */}
          <div className="cursor ml10" onClick={() => handleEdit(pln)}>
            <div className="flex-center">
              <EditIcon sx={eyeBtn} />
            </div>
            <Typography className="blue-color fs8 txt-semi-bold text-align-center">
              Edit
            </Typography>
          </div>
        </div>
      ),
    }));
  };

  const handleCreate = () => {
    setSelectedTemp(null);
    setCreateVsble(true);
  };

  return (
    <>
      {createVsble ? (
        <DiagnosticTemplateCreate
          setCreateVsble={setCreateVsble}
          selectedTemp={selectedTemp}
          setSelectedTemp={setSelectedTemp}
        />
      ) : null}
      {!createVsble && (
        <div>
          <div className="flex-row-ali-cen flex-center mt5">
            <div className="w30Per">
              <CustomTextField
                placeholder="Search"
                name="name"
                fullWidth
                handleChange={(e) => setSearchValue(e?.target?.value)}
                value={searchValue}
                backgroundColor={AppColors.lightBlue2}
              />
            </div>
            <div className="w7Per ml20">
              <CustomButton text="Create" onClick={handleCreate} smallBtn />
            </div>
          </div>

          <CustomTable columns={tableHeader} datas={getTableList()} grey />
        </div>
      )}

      <CustomModal
        open={delModVsble}
        onClose={handleCloseDel}
        header="Delete"
        modal
        modalWidth={30}
      >
        <div className="ml10">Are you sure want to delete the template?</div>
        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleCloseDel} smallBtn />
          </div>
          <div className="ml20">
            <CustomButton
              redBtn
              text="Confirm"
              onClick={handleConfirmDel}
              smallBtn
            />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default DiagnosticTemplate;
